import { NgModule } from '@angular/core';
import { SharedModule } from './../../../shared/modules/shared.module';

import { AnnualRenewalPayNowComponent } from './annual-renewal-paynow.component';
import { PayNowCheckoutComponent } from './paynow-checkout/paynow-checkout.component';
import { PayNowPaymentComponent } from './paynow-checkout/paynow-payment/paynow-payment.component'
import { PayNowConfirmationComponent } from './paynow-confirmation/paynow-confirmation.component'

//import { ProductListComponent } from './../../checkout/shared/product-list/product-list.component';
import { ProductListComponent} from './product-list/product-list.component';
import { ProductRowComponent } from './product-list/product-row/product-row.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule,
    NgxMaskModule
  ],
  declarations: [
    AnnualRenewalPayNowComponent,
    PayNowCheckoutComponent,
    PayNowPaymentComponent,
    ProductListComponent,
    ProductRowComponent,
    PayNowConfirmationComponent
  ]
})
export class AnnualRenewalPayNowModule { }
